module.exports = __webpack_public_path__ + "static/media/header.39580df2.jpg";